<script>
import Layout from '@layouts/main'
import LayoutContent from '@layouts/content'
import PageTitle from '@components/page-title'

export default {
  components: { Layout, LayoutContent, PageTitle },
  props: {
    resource: {
      type: String,
      default: '',
    },
  },
}
</script>

<template>
  <Layout>
    <PageTitle title="404" />
    <LayoutContent>
      <h1 :class="$style.title">
        404
        <span v-if="resource">
          {{ resource }}
        </span>
        Not Found
      </h1>
    </LayoutContent>
  </Layout>
</template>

<style lang="scss" module>
.title {
  text-align: center;
}
</style>
